export function isActionOf(actionOrActions) {
    return function (action) {
        if (actionOrActions == null) {
            throw new Error('first argument is missing');
        }
        if (!Array.isArray(actionOrActions)) {
            if (actionOrActions.getType == null) {
                throw new Error('first argument is not an instance of "typesafe-actions"');
            }
        }
        var actionCreators = Array.isArray(actionOrActions)
            ? actionOrActions : [actionOrActions];
        return actionCreators.some(function (actionCreator, index) {
            if (actionCreator.getType == null) {
                throw new Error("element of the first argument with index [" + index + "]\n          is not an instance of \"typesafe-actions\"");
            }
            return actionCreator.getType() === action.type;
        });
    };
}
//# sourceMappingURL=is-action-of.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/typesafe-actions/es5-module/is-action-of.js
// module id = 1012
// module chunks = 9